import React from "react";
import { 
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface DeleteConfirmationDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onDelete: () => void;
  isDeleting: boolean;
  title?: string;
  description?: string;
  itemName?: string;
  itemType?: string;
}

export const DeleteConfirmationDialog: React.FC<DeleteConfirmationDialogProps> = ({
  isOpen,
  onOpenChange,
  onDelete,
  isDeleting,
  title = "Delete session",
  description = "Are you sure you want to delete this session?",
  itemName,
  itemType = "session"
}) => {
  
  const handleDelete = () => {
    onDelete();
  };
  
  // Build the full description with item name if provided
  const fullDescription = () => {
    if (itemName) {
      return (
        <>
          {description}
          <div className="mt-2 ml-2">
            <span className="font-medium">• {itemName}</span>
          </div>
          <div className="mt-2">
            This action cannot be undone.
          </div>
        </>
      );
    }
    return `${description} This action cannot be undone.`;
  };
  
  return (
    <AlertDialog open={isOpen} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>
            {fullDescription()}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isDeleting}>Cancel</AlertDialogCancel>
          <AlertDialogAction 
            onClick={handleDelete}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
            disabled={isDeleting}
          >
            {isDeleting ? "Deleting..." : "Delete"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
